// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeZ7oEcVIOT8PU {
  color: var(--ds-text-subtlest, #626f86);
}
.e85Vb4Mxhp9W6q {
  display: block;
  max-width: 600px;
  margin: 75px auto;
  text-align: center;
}
.e85Vb4Mxhp9W6q h1 {
  margin-bottom: var(--ds-space-150, 12px);
  font-size: 26px;
}
.e85Vb4Mxhp9W6q p {
  font-size: 18px;
  line-height: 22px;
}
.Ecwtim9lWLikiz {
  margin-top: 36px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quiet": `HeZ7oEcVIOT8PU`,
	"bigMessage": `e85Vb4Mxhp9W6q`,
	"tryAgainButton": `Ecwtim9lWLikiz`
};
export default ___CSS_LOADER_EXPORT___;
